import type React from 'react';
import { Separator } from '@heroui/react';
import type { NameSectionModel } from '../../useNamesStep';
import { NameRow } from '../nameRow';

/** What every row of the list takes, and the rows themselves. */
type NameRowsProps = Omit<React.ComponentProps<typeof NameRow>, 'row'> & {
    rows: NameSectionModel['rows'];
};

/** A section's names, one `NameRow` each, between `Separator`s. */
export const NameRows: React.FC<NameRowsProps> = ({ rows, ...rowProps }) => (
    <ul className="flex flex-col">
        {rows.map((row, index) => (
            <li key={row.text}>
                {index > 0 ? <Separator /> : null}
                <NameRow {...rowProps} row={row} />
            </li>
        ))}
    </ul>
);
